/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryFeesDetails
 */
export interface ProposalSummaryFeesDetails {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    initialAdviceFeeExclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    initialAdviceFeeInclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    initialAdviceFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    recurringAdviceFeeExclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    recurringAdviceFeeInclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    recurringAdviceFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    annualAdviceFeeExclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    annualAdviceFeeInclVat?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeesDetails
     */
    annualAdviceFeePercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryFeesDetails interface.
 */
export function instanceOfProposalSummaryFeesDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryFeesDetailsFromJSON(json: any): ProposalSummaryFeesDetails {
    return ProposalSummaryFeesDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryFeesDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryFeesDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'initialAdviceFeeExclVat': !exists(json, 'InitialAdviceFeeExclVat') ? undefined : json['InitialAdviceFeeExclVat'],
        'initialAdviceFeeInclVat': !exists(json, 'InitialAdviceFeeInclVat') ? undefined : json['InitialAdviceFeeInclVat'],
        'initialAdviceFeePercentage': !exists(json, 'InitialAdviceFeePercentage') ? undefined : json['InitialAdviceFeePercentage'],
        'recurringAdviceFeeExclVat': !exists(json, 'RecurringAdviceFeeExclVat') ? undefined : json['RecurringAdviceFeeExclVat'],
        'recurringAdviceFeeInclVat': !exists(json, 'RecurringAdviceFeeInclVat') ? undefined : json['RecurringAdviceFeeInclVat'],
        'recurringAdviceFeePercentage': !exists(json, 'RecurringAdviceFeePercentage') ? undefined : json['RecurringAdviceFeePercentage'],
        'annualAdviceFeeExclVat': !exists(json, 'AnnualAdviceFeeExclVat') ? undefined : json['AnnualAdviceFeeExclVat'],
        'annualAdviceFeeInclVat': !exists(json, 'AnnualAdviceFeeInclVat') ? undefined : json['AnnualAdviceFeeInclVat'],
        'annualAdviceFeePercentage': !exists(json, 'AnnualAdviceFeePercentage') ? undefined : json['AnnualAdviceFeePercentage'],
    };
}

export function ProposalSummaryFeesDetailsToJSON(value?: ProposalSummaryFeesDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InitialAdviceFeeExclVat': value.initialAdviceFeeExclVat,
        'InitialAdviceFeeInclVat': value.initialAdviceFeeInclVat,
        'InitialAdviceFeePercentage': value.initialAdviceFeePercentage,
        'RecurringAdviceFeeExclVat': value.recurringAdviceFeeExclVat,
        'RecurringAdviceFeeInclVat': value.recurringAdviceFeeInclVat,
        'RecurringAdviceFeePercentage': value.recurringAdviceFeePercentage,
        'AnnualAdviceFeeExclVat': value.annualAdviceFeeExclVat,
        'AnnualAdviceFeeInclVat': value.annualAdviceFeeInclVat,
        'AnnualAdviceFeePercentage': value.annualAdviceFeePercentage,
    };
}

